(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-cards.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-cards.js');

'use strict';

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const activeCharitiesAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.activeCharitiesAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_charity.react.components,
  SelectCharityCard = _svs$lyckoplatsen$com.SelectCharityCard,
  MoreCharitiesText = _svs$lyckoplatsen$com.MoreCharitiesText;
const CharityCards = () => {
  const activeCharities = useAtomValue(activeCharitiesAtom);
  if (!activeCharities) {
    return null;
  }
  return React.createElement("div", {
    className: "lp-charity-cards-container charity-grid"
  }, React.createElement("div", {
    className: "charity-grid-body charity-grid-nested"
  }, activeCharities.map(c => React.createElement(SelectCharityCard, {
    charity: c,
    key: c.charityId
  })), React.createElement("div", {
    className: "padding-h-1"
  }, React.createElement(MoreCharitiesText, null))));
};
Object.assign(svs.lyckoplatsen.components.page_charity_payout.react.components, {
  CharityCards
});

 })(window);